module.exports = __webpack_public_path__ + "static/media/growth.78a613fb.svg";